export class ReleaseFormsList {
    id: number;
    form_name: string;
    edit_access: boolean;

    constructor(id: number, form_name: string, edit_access: boolean) {
        this.id = id;
        this.form_name = form_name;
        this.edit_access = edit_access;
    }
}

export class ReleaseFormDetails {
    id: number;
    pet_det: boolean;
    procedures: string;
    prompt: string;
    form_name: string;
    actionType: string;
    role_access: string;

    constructor(id: number, pet_det: boolean, procedures: string, prompt: string, form_name: string, actionType: string, role_access:string) {
        this.id = id;
        this.pet_det = pet_det;
        this.procedures = procedures;
        this.prompt = prompt;
        this.form_name = form_name;
        this.actionType = actionType;
        this.role_access = role_access;
    }
}